var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrossCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M14.007 28C21.69 28 28 21.689 28 14.007 28 6.311 21.689 0 13.993 0 6.31 0 0 6.311 0 14.007 0 21.69 6.311 28 14.007 28zm0-1.085c-7.14 0-12.922-5.783-12.922-12.908 0-7.125 5.783-12.922 12.908-12.922 7.14 0 12.922 5.797 12.922 12.922 0 7.125-5.783 12.908-12.908 12.908zm-5.126-7.182c.172 0 .3-.043.443-.2l4.669-4.683 4.683 4.683c.157.143.286.2.457.2.314 0 .571-.229.571-.543 0-.171-.057-.3-.185-.428l-4.712-4.712 4.712-4.712c.128-.143.185-.257.185-.428 0-.3-.257-.543-.57-.543-.172 0-.287.057-.444.2l-4.697 4.683L9.31 8.581c-.143-.157-.257-.2-.429-.2-.328 0-.585.229-.585.529 0 .171.057.3.2.428l4.697 4.712-4.697 4.712a.551.551 0 00-.2.428c0 .314.257.543.585.543z",
    fill: "#fff"
  })));
}

export default SvgCrossCircle;